import { ON_MOBILE_DEVICE_REGISTERED_BY_ID, ON_REGISTRATION_TOKEN_SAVED_BY_ID } from 'graphql/subscriptions';
import { mockedOnMobileDeviceRegisteredDataForSubscription } from '../graphqlApollo/subscription/onMobileDeviceRegistered';
import { mockedOnRegistrationTokenSavedDataForSubscription } from '../graphqlApollo/subscription/onRegistrationTokenSaved';

export const subscriptions = [
  {
    request: {
      query: ON_MOBILE_DEVICE_REGISTERED_BY_ID,
      variables: { visitorId: 'mockedBobVisitorId' }
    },
    newData: () => ({
      data: mockedOnMobileDeviceRegisteredDataForSubscription
    })
  },
  {
    request: {
      query: ON_REGISTRATION_TOKEN_SAVED_BY_ID,
      variables: { visitorId: 'mockedBobVisitorId' }
    },
    newData: () => ({
      data: mockedOnRegistrationTokenSavedDataForSubscription
    })
  }
];
